(function () {
    'use strict';
    angular.module('AngularAdmin')
        .factory('ForecastSvc', ['$http', function ($http) {
            return {
                getUrl: function (plant_id, report_type, from, to, resolution, suffix = "", format = "json") {
                    return String.format('/plant/{0}/report/{1}/{4}/{2}/{3}/?format={5}' + suffix, plant_id, report_type, from, to, resolution, format);
                },
                get: function (plant_id, report_type, from, to, resolution, suffix = "") {
                    let url = this.getUrl(plant_id, report_type, from, to, resolution, suffix);

                    return $http({
                        url: url
                    });
                }
            };
        }]);
})();
